import { getAllPessoas, savePessoa, updatePessoa, deletePessoa } from '@/services/api/pessoa.js';
export const actions = {
  async getAllPessoas(state) {
    try {
      const dataList = await getAllPessoas();
      state.commit('SET_LIST', dataList);
      return dataList;
      /* eslint-disable */
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async savePessoa(state, payload) {
    try {
      await savePessoa(payload);
      state.dispatch(
        'modal/showModal',
        {
          title: 'Cadastro realizado',
          message: `Cadastrado com sucesso.`,
          buttonText: 'FECHAR',
        },
        {
          root: true,
        }
      );
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async updatePessoa(state, payload) {
    try {
      await updatePessoa(payload);
      state.dispatch(
        'modal/showModal',
        {
          title: 'Cadastro realizado',
          message: `Cadastrado com sucesso.`,
          buttonText: 'FECHAR',
        },
        {
          root: true,
        }
      );
    } catch (error) {
      console.log(error)
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async deletePessoa(state, payload) {
    try {
      await deletePessoa(payload);
    } catch (error) {
      /* eslint-disable */
      console.log(error)
      state.dispatch(
        'modal/showModal',
        {
          title: 'Cadastro Atualizado',
          message: `Editado com sucesso.`,
          buttonText: 'FECHAR',
        },
        {
          root: true,
        }
      );
    }
  },
}
